module.exports = __webpack_public_path__ + "80626c8a9e5bf2f274f5d72559ffa0f6.svg";